export const FORMAT_BADGE_STYLES: Record<string, { label: string; bg: string; text: string; color: string }> = {
    _20K: { label: '20K', bg: '#fef9c3', text: '#854d0e', color: '#fdfd03' },
    _50K: { label: '50K', bg: '#fff7ed', text: '#c2410c', color: '#f85900' },
    _100K: { label: '100K', bg: '#dcfce7', text: '#15803d', color: '#7bda63' },
    _100M: { label: '100M', bg: '#fee2e2', text: '#dc2626', color: '#f32626' },
};
